import { ButtonType } from "./types";

export const BUTTON_TYPES = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  OUTLINE: "outline",
  OUTLINE_DANGER: "outline-danger",
  OUTLINE_NEUTRAL: "outline-neutral",
  LINK: "link",
  LINK_NEUTRAL: "link-neutral",
  LINK_DANGER: "link-danger",
  CIRCLE: "circle",
  ICON: "icon",
  TRANSPARENT: "transparent",
} as const;

export const BUTTON_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
} as const;

/** Типы кнопок которые могут использоваться с параметром isLoading */
export const BUTTON_TYPES_WITH_LOADER = [
  BUTTON_TYPES.PRIMARY,
  BUTTON_TYPES.SECONDARY,
  BUTTON_TYPES.OUTLINE,
  BUTTON_TYPES.OUTLINE_DANGER,
  BUTTON_TYPES.OUTLINE_NEUTRAL,
] as ButtonType[];
